module.exports = __webpack_public_path__ + "static/media/mail.1e7623eb.svg";